import { useEffect, useState, useContext } from 'react'
import { ReportingContext } from '../../../../contexts/reporting-context'
import DataCard from '../../../atoms/DataCard/datacard'
import { SeatBooking } from '../../../../types/andTypes'
import dayjs from 'dayjs'

export const MostPopularDay = () => {
  const { reportSeatBookingsByTeam } = useContext(ReportingContext)
  const [popularDay, setPopularDay] = useState('')

  useEffect(() => {
    reportSeatBookingsByTeam.length === 0
      ? setPopularDay('-')
      : setPopularDay(findPopularDay(reportSeatBookingsByTeam))
  }, [reportSeatBookingsByTeam])

  const findPopularDay = (reportSeatBookings: SeatBooking[]) => {
    const popularDayMap: Record<string, number> = {}
    reportSeatBookings.forEach(data => {
      const day = dayjs(data.dateBooked).format('dddd')
      const seats = data.seats.length
      popularDayMap[day] = popularDayMap[day] !== undefined ? popularDayMap[day] + seats : seats
    })
    let day = ''
    let maxSeat = 0
    Object.keys(popularDayMap).forEach(weekday => {
      if (popularDayMap[weekday] > maxSeat) {
        maxSeat = popularDayMap[weekday]
        day = weekday
      }
    })
    return day
  }

  return (
    <DataCard
      id="most-popular-day-card"
      title="Most Popular Day"
      content={{ mainValue: popularDay }}
    />
  )
}
